import React from 'react';
import { FaPhone } from 'react-icons/fa';

function Footer() {
  return (
    <footer className="border-t border-slate-700 py-8 md:py-12 w-full" style={{backgroundColor: '#0a0a0a'}}>
      <div className="container px-4 md:px-6 mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 mb-8">
          {/* Hakkımızda */}
          <div className='flex flex-col items-center md:items-start'>
            <h2 className="text-base md:text-lg font-freeman mb-4 md:mb-6 text-white font-semibold">Hakkımızda</h2>
            <div className="flex flex-col space-y-2 items-center mb-4 md:mb-6 gap-4 md:gap-6 text-center w-full">
              <img src="ozturkkerestebeyaz.png" alt="Logo" className="h-20 md:h-24 hover:opacity-80 transition-opacity duration-300" />
              <div className='flex flex-col gap-2 md:gap-3 w-full'>
                <a href="tel:905404535345" className="flex items-center gap-3 text-gray-100 border border-slate-600 hover:border-primary hover:text-primary hover:bg-primary/10 px-4 md:px-5 py-3 md:py-4 rounded-lg font-freeman transition-all duration-300 text-xs md:text-sm justify-center md:justify-start">
                  <FaPhone className="w-4 h-4 flex-shrink-0" />
                  <div className="flex flex-col px-4">
                    <span className="font-semibold">İSMAİL ÖZTÜRK</span>
                    <span className="text-xs">0540 453 5345</span>
                  </div>
                </a>
                <a href="tel:905415353561" className="flex items-center gap-3 text-gray-100 border border-slate-600 hover:border-primary hover:text-primary hover:bg-primary/10 px-4 md:px-5 py-3 md:py-4 rounded-lg font-freeman transition-all duration-300 text-xs md:text-sm justify-center md:justify-start">
                  <FaPhone className="w-4 h-4 flex-shrink-0" />
                  <div className="flex flex-col px-4">
                    <span className="font-semibold">MUSTAFA ÖZTÜRK</span>
                    <span className="text-xs">0541 535 3561</span>
                  </div>
                </a>
              </div>
            </div>
          </div>
          {/* Çalışma Saatleri */}
          <div className='flex flex-col items-center md:items-start'>
            <h2 className="text-base md:text-lg font-freeman mb-4 md:mb-6 text-white font-semibold">Çalışma Saatleri</h2>
            <div className="space-y-3 md:space-y-4 w-full text-center md:text-left">
              <div>
                <p className='font-freeman text-xs md:text-sm text-gray-300 font-semibold'>Hafta İçi</p>
                <p className='font-freeman text-gray-100 text-sm md:text-base'>07:00 - 19:00</p>
              </div>
              <div>
                <p className='font-freeman text-xs md:text-sm text-gray-300 font-semibold'>Cumartesi</p>
                <p className='font-freeman text-gray-100 text-sm md:text-base'>07:00 - 19:00</p>
              </div>
              <div>
                <p className='font-freeman text-xs md:text-sm text-gray-300 font-semibold'>Pazar</p>
                <p className='font-freeman text-gray-100 font-semibold text-sm md:text-base'>KAPALI</p>
              </div>
            </div>
          </div>
          {/* İletişim */}
          <div className='flex flex-col items-center md:items-start'>
            <h2 className="text-base md:text-lg font-freeman mb-4 md:mb-6 text-white font-semibold">İletişim</h2>
            <div className="flex flex-col space-y-2 text-center md:text-left w-full">
              <a href="https://wa.me/+905404535345" target='_blank' rel="noreferrer" className="text-white font-freeman bg-primary hover:bg-secondary px-3 py-2 rounded-lg transition-colors duration-300 text-xs md:text-sm">Whatsapp</a>
              <a href="mailto:ozturkkeresteagacsanayi@gmail.com" className="text-gray-100 border border-slate-600 hover:border-primary hover:text-primary px-3 py-2 rounded-lg font-freeman transition-all duration-300 text-xs md:text-sm">Mail Gönder</a>
              <a href="https://www.instagram.com/ozturkkerestecilik" target='_blank' rel="noreferrer" className="text-gray-100 border border-slate-600 hover:border-primary hover:text-primary px-3 py-2 rounded-lg font-freeman transition-all duration-300 text-xs md:text-sm">İnstagram</a>
              <a href="https://www.facebook.com/ozturkkeresteagacsanayi" target='_blank' rel="noreferrer" className="text-gray-100 border border-slate-600 hover:border-primary hover:text-primary px-3 py-2 rounded-lg font-freeman transition-all duration-300 text-xs md:text-sm">Facebook</a>
            </div>
            <p className='font-freeman text-xs text-gray-400 mt-3 md:mt-4'>Gaziler Mahallesi 600. Sokak No:31<br/>Manisa/Salihli</p>
          </div>
        </div>
        
        <div className="border-t border-slate-700 pt-6">
          <p className="text-center text-xs text-gray-400 font-freeman">
            © 2026 Öztürk Kereste. Tüm hakları saklıdır.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;